import * as React from "react";
import { BookOpenText, Clock, Wand2 } from "lucide-react";
import { ulid } from "ulid";
import { SidebarPromptImprovements } from "@/views/open-chat/components/sidebar/sidebarPromptImprovements";
import { SidebarHistory } from "./sidebarHistory";
import { PromptLibraryRightDrawer } from "@/modules/promptLibrary/components/promptLibraryRightDrawer";
import { clsx } from "clsx";

export type OpenChatSidebarTab = "prompt" | "history" | "promptLibrary";

interface Props {
  tab: OpenChatSidebarTab;
  setTab: React.Dispatch<React.SetStateAction<OpenChatSidebarTab>>;
}

export const OpenChatSidebar: React.FC<Props> = ({ setTab, tab }) => {
  const [conversationId] = React.useState(() => ulid());

  return (
    <div className="relative flex w-[50%] flex-shrink-0 overflow-y-auto">
      <div className="flex h-[95vh] w-full flex-col overflow-hidden rounded-xl shadow">
        <div className="flex items-center justify-between border-b border-gray-200 bg-white p-4">
          <div className="flex gap-4">
            <div
              className={clsx(
                "flex cursor-pointer flex-wrap items-center justify-start space-x-2 rounded p-2 lg:flex-nowrap",
                {
                  "bg-blue-100": tab === "prompt",
                },
              )}
              onClick={() => setTab("prompt")}
            >
              <Wand2 size={20} className="mr-2" />
              <span>Prompt Generator</span>
            </div>
            <div
              className={clsx(
                "flex cursor-pointer flex-wrap items-center justify-start space-x-2 rounded p-2 lg:flex-nowrap",
                {
                  "bg-blue-100": tab === "promptLibrary",
                },
              )}
              onClick={() => setTab("promptLibrary")}
            >
              <BookOpenText className="cursor-pointer" size={20} />
              <span>Prompt Library</span>
            </div>
          </div>
          <Clock
            className={clsx("cursor-pointer rounded p-2", {
              "bg-blue-100": tab === "history",
            })}
            size={36}
            onClick={() => setTab("history")}
          />
        </div>

        {tab === "prompt" && <SidebarPromptImprovements conversationId={conversationId} />}
        {tab === "history" && <SidebarHistory conversationId={conversationId} />}
        {tab === "promptLibrary" && <PromptLibraryRightDrawer source="open_chat" />}
      </div>
    </div>
  );
};
